'use client';

import {
  Button,
  Typography,
  TypographyMods,
  TypographySizes,
} from '@vk-cloud-solutions/marketing-ui';
import classNames from 'classnames';

import { CardDraftLabel } from '~components/CardDraftLabel/CardDraftLabel';
import { NextImage } from '~components/NextImage/NextImage';
import { NextImageMods } from '~components/NextImage/NextImage.types';
import { Section } from '~components/Section/Section';
import { HeaderSection } from '~containers/MainPage/HeaderSection/HeaderSection';

import styles from './SectionTopic.module.scss';
import { SectionTopicProps } from './SectionTopic.types';

export function SectionTopic({
  title,
  titleBacklight,
  article,
  ...sectionProps
}: SectionTopicProps) {
  return (
    <Section className={classNames(styles.section)} {...sectionProps}>
      {title && (
        <HeaderSection
          title={title}
          titleBacklight={titleBacklight}
          hasPageCategory={false}
          hasIcon={true}
        />
      )}
      <div
        className={classNames(
          styles.article,
          article.imageWithBg && styles.imageWithBg,
        )}
      >
        {!article.publishedAt && <CardDraftLabel />}
        <div className={styles.articleContent}>
          {!!article.categories?.length && (
            <div className={styles.articleCategoryList}>
              {article.categories?.map((category) => (
                <Typography
                  tagName={TypographySizes.div}
                  mods={[TypographyMods.bodyM]}
                  className={styles.articleCategory}
                  key={category.id}
                >
                  {category.title}
                </Typography>
              ))}
            </div>
          )}
          <Typography
            tagName={TypographySizes.h3}
            mods={[TypographyMods.titleXl]}
            className={styles.articleTitle}
          >
            {article.title}
          </Typography>
          <Typography
            tagName={TypographySizes.p}
            mods={[TypographyMods.bodyS]}
            className={styles.articleText}
          >
            {article.text}
          </Typography>
          <Button
            className={styles.articleButton}
            href={article.href}
            text="Подробнее"
            size="m"
            mod="tertiary"
          />
        </div>
        {article.image && (
          <div className={styles.articleMedia}>
            <NextImage
              className={styles.articleImage}
              mods={!article.imageWithBg ? [NextImageMods.FitContain] : []}
              {...article.image}
            />
          </div>
        )}
      </div>
    </Section>
  );
}
